export class CardModel {
  auto_id?: number;
  cardId: any;
  memberId: any;
  cardNo: any;
  cardStartDate: any;
  cardEndDate: any;
  cardActive: any;
  cardPrinted: any;
  cardEncoded: any;
  cardCollected: any;
  cardSerialNo: any;
  cardTotalFarmHectare: any;
  cardNotes: any;
  officeId: any;
  cardCancelled: any;
  cardCancelReason: any;
  cardCancelledBy: any;
  collectionDate: any;
  collectorIC: any;
  collectorIssuer: any;
  cardRenewed: any;
  cardReissued: any;
  cardReissuedReason: any;
  cardReissuedCount: any;
  cardRefNo: any;
  cardCreatedBy: any;
  cardCreatedDate: any;
  lastUpdate: any;
  personUpdate: any;
  cardExpired: any;
  cardReqApproval: any;
  cardApprovalType: any;
  cardApprovalReqBy: any;
  cardOrg: any;
  cardLGMSerialNo: any;
  cardCollectionDate: any;
  cardCollectionMethod: any;
  cardIsImm: any;
  cardImmYear: any;
  cardIsAgency: any;
  cardAgencyId: any;
  cardInProcess: any;
  cardCatId: any;
  cardReqUpdate: any;
  cardUpdated: any;
  cardSubCatId: any;
  cardNewChangeApplication: any;
  CardReqApprovalL1: any;
  CardBatchId: any;
  cardChangeSubcat: any;
  cardApprovedBy: any;
  cardStatus: any;

  agencyName: any;
  subCatName: any;
  restrictionDetails:any;
  cardStatusName:any;
  patgOnlineInProcess: number;
  patgOnlineProcessType: number;
  
  processStatus: any;
}
